"use strict";var e=require("./tokeniseString.cjs"),n=require("./transformToPlaybackSentenceCase.cjs");exports.playbackSentenceCase=function(r){return e.tokeniseString(r).map(n.transformToPlaybackSentenceCase).join(" ")};
//# sourceMappingURL=playbackSentenceCase.cjs.map
